import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ClickOutSideDirective } from '@directives/click-out-side.directive';
import { RectangeArrowSvgIconComponent } from '@components/svg-icons/rectange-arrow-svg-icon/rectange-arrow-svg-icon.component';
import { MenuActions } from '../../../states/menu_actions';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-movil-menu-button',
  imports: [ClickOutSideDirective, ClickOutSideDirective, RectangeArrowSvgIconComponent, TranslocoPipe],
  templateUrl: './ln-movil-menu-button.component.html',
  styleUrl: './ln-movil-menu-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnMovilMenuButtonComponent {
  menuActions = inject(MenuActions);
  expanded = false;

  ExpandedToggle() {
    this.expanded = !this.expanded;
  }

  CloseMenu() {
    this.expanded = false;
  }

  navigateToAboutUsPage(): void {
    this.menuActions.navigateToAboutUsPage();
  }

  navigateToServicesPage(): void {
    this.menuActions.navigateToServices();
  }

  navigateToLunaNuevaBlog() {
    this.menuActions.navigateToBlog();
  }
}
